<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M13.9987 2.3335C7.54703 2.3335 2.33203 7.5485 2.33203 14.0002C2.33203 20.4518 7.54703 25.6668 13.9987 25.6668C20.4504 25.6668 25.6654 20.4518 25.6654 14.0002C25.6654 7.5485 20.4504 2.3335 13.9987 2.3335ZM19.832 18.1885L18.187 19.8335L13.9987 15.6452L9.81036 19.8335L8.16537 18.1885L12.3537 14.0002L8.16537 9.81183L9.81036 8.16683L13.9987 12.3552L18.187 8.16683L19.832 9.81183L15.6437 14.0002L19.832 18.1885Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'WhiteCloseIcon28'
};
</script>

<style scoped>

</style>
